/**
 * BetaBadge — small gold pill used on nav entries that are still in beta.
 *
 * Currently used on the "Sports" pill (desktop + mobile bottom nav)
 * while the SABA integration is scaffolded ahead of real credentials.
 * Thin wrapper around the existing `Badge` component so all beta chips
 * stay visually identical across the app.
 */
import { Badge } from "./ui-r1/Badge";

export default function BetaBadge({ className = "" }) {
  return (
    <Badge variant="gold" className={"px-1 py-0 !text-[8px] tracking-[0.28em] " + className}>
      BETA
    </Badge>
  );
}
